class Optimonk {

    constructor() {
        this.maxClearAttempts = 5;
        this.clearAttemtps = 0;
    }
    
    addToCart(item) {
        if (typeof window.OptiMonk !== 'undefined' && typeof window.OptiMonk.Visitor !== 'undefined') {
            let adapter = window.OptiMonk.Visitor.createAdapter();
            adapter.Cart.add(item.title, {quantity: 1, price: item.price});
            //console.log('[Optimonk::addToCart] Added');
        }
    }

    deleteFromCart(item) {
        if (typeof window.OptiMonk !== 'undefined' && typeof window.OptiMonk.Visitor !== 'undefined') {
            let adapter = window.OptiMonk.Visitor.createAdapter();
            adapter.Cart.remove(item.title);
            //console.log('[Optimonk::deleteFromCart] Deleted');
        }
    }

    clearCart() {
        if (typeof window.OptiMonk !== 'undefined' && typeof window.OptiMonk.Visitor !== 'undefined') {
            let adapter = window.OptiMonk.Visitor.createAdapter();
            adapter.Cart.clear();
            this.clearAttemtps = 0;
            //console.log('[Optimonk::clearCart] Cleared');
        } else if (this.clearAttemtps < this.maxClearAttempts) {
            setTimeout(() => {
                this.clearCart();
            }, 500);
            this.clearAttemtps++;
        }
    }

}

export default Optimonk;